export default __webpack_public_path__ + "static/gradient-7a18b5db8021333ef182738ffd186b49.png";